import React from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/revenueBreakdownSagas";

import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import PreviousYearMonthToDate from "./smartComponents/previousYearMonthToDate";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import Forecast from "./smartComponents/forecast";
import LearnMore from "../../../components/learnMore/learnMore";
import RevenuePieChart from "./smartComponents/revenuePieChart";
import RevenueByType from "./smartComponents/revenueByType";
import MonthToDate from "./smartComponents/monthToDate";
import YearToDate from "./smartComponents/yearToDate";
import { useFetchDataWithRevenueType } from "../hooks/dataFetchingHooks";

const RevenueBreakdownModule = (props) => {
  useFetchDataWithRevenueType({
    moduleName: "revenueBreakdown",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });
  const isLoading = useSelector((state) => state.revenueBreakdown.isLoading);

  const renderContent = () => {
    return (
      <div>
        <div className="section-group">
          <span className="width-50">
            <SectionContainer title="Month To Date">
              <MonthToDate />
            </SectionContainer>
          </span>
          <span className="width-50">
            <SectionContainer title="Month to Date this time Last Year">
              <PreviousYearMonthToDate />
            </SectionContainer>
          </span>
          <SectionContainer title="Revenue By Category MTD" customStyles="pie-chart">
            <RevenuePieChart />
          </SectionContainer>
        </div>
        <div className="section-group">
          <span className="width-50">
            <Forecast />
          </span>
          <span className="width-50">
            <SectionContainer title="Year to Date">
              <YearToDate />
            </SectionContainer>
          </span>
          <SectionContainer title="">
            <RevenueByType />
          </SectionContainer>
        </div>
      </div>
    );
  };

  return (
    <SectionToggle
      title="Revenue Breakdown"
      learnMore={<LearnMore {...props.learnMore} html />}
      customClass="revenueDetailsWidget"
      isLoading={isLoading}
      content={renderContent()}
    />
  );
};

export default RevenueBreakdownModule;
